let enginePromise

export function loadPdfEngine() {
  if (window.wjtPdfjs) return Promise.resolve(window.wjtPdfjs)
  if (!enginePromise) {
    enginePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'module'
      script.src = '/static/pdfjs-loader.js'
      script.onload = () => {
        if (window.wjtPdfjs) resolve(window.wjtPdfjs)
        else fail()
      }
      const fail = () => {
        enginePromise = null
        script.remove()
        reject(new Error('PDF preview engine unavailable'))
      }
      script.onerror = fail
      document.head.appendChild(script)
    })
  }
  return enginePromise
}

export function resolvePdfUrl(source, baseUrl) {
  const url = new URL(source, baseUrl)
  if (!/^https?:$/.test(url.protocol)) throw new Error('Unsupported PDF URL')
  const backend = new URL(process.env.DOMAIN_URL)
  if (url.hostname === backend.hostname && url.port === backend.port && url.pathname.indexOf('/profile/') === 0) {
    return url.pathname + url.search
  }
  return url.href
}

export function canvasLayout(pageWidth, pageHeight, availableWidth, zoom, devicePixelRatio) {
  const width = Math.max(1, availableWidth) * zoom / 100
  const height = width * pageHeight / pageWidth
  const outputScale = Math.min(devicePixelRatio || 1, 2, Math.sqrt(8000000 / (width * height)), 16384 / width, 16384 / height)
  return {
    width, height, scale: width / pageWidth, outputScale,
    pixelWidth: Math.max(1, Math.floor(width * outputScale)),
    pixelHeight: Math.max(1, Math.floor(height * outputScale))
  }
}



// WEBPACK FOOTER //
// ./src/js/pdf-preview.js